import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Badge from '@material-ui/core/Badge';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import HelpIcon from '@material-ui/icons/HelpOutline';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import { Link } from 'react-router-dom';
import WarningIcon from '@material-ui/icons/Warning';
import Button from '@material-ui/core/Button';
import { getProfile } from '../../../utils/authenticated';
import { UPGRADE_DIALOG } from '../../../redux/constants/dialogs';

const styles = theme => ({
  root: {
    width: '100%',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  logo: {
    height: 40,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing.unit * 2,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit * 3,
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  account: {
    margin: 'auto',
  },
});

class PrimarySearchAppBar extends React.Component {
  state = {
    anchorEl: null,
    mobileMoreAnchorEl: null,
  };

  renderTrial = () => {
    return (<div style={styles.row}>
      <div style={styles.column}>
        <WarningIcon color="white" style={styles.warningIcon}/>
      </div>
      <div style={styles.column}>
        <div>Free Trial</div>
      </div>
      <div style={styles.column}>
        <Button
          variant="contained"
          color="secondary"
          style={styles.upgrade}
          onClick={() => this.props.showDialog(UPGRADE_DIALOG)}>Upgrade</Button>
      </div>
    </div>);
  };

  renderUserMenu = () => {
    const { account } = this.props;
    const user = getProfile();

    if (user) {
      return (<div style={styles.row}>
        {account.settings && account.settings.plan ? null : this.renderTrial()}
        <div style={styles.column}>
          <span
            style={styles.employeeName}>{user && user.user_metadata ? `${user.user_metadata.firstName || ''} ${user.user_metadata.lastName || ''}` : 'Unknown'}</span>
          <span style={styles.accountName}>{account.name || 'Unknown'}</span>
        </div>
        {/*<IconMenu*/}
        {/*iconButtonElement={*/}
        {/*<IconButton iconStyle={styles.icon}><MoreVertIcon /></IconButton>*/}
        {/*}*/}
        {/*targetOrigin={{ horizontal: 'right', vertical: 'top' }}*/}
        {/*anchorOrigin={{ horizontal: 'right', vertical: 'top' }}*/}
        {/*>*/}
        {/*<MenuItem primaryText="Help" containerElement={<Link target="_blank" to="https://help.staza.io"/>}/>*/}
        {/*<MenuItem primaryText="Log out" onClick={() => this.props.logoutUser() }/>*/}
        {/*</IconMenu>*/}
      </div>);
    } else {
      return (<Button
        variant="text"
      >Login</Button>);
    }
  };

  render() {
    const { classes, onLogout, showProfile } = this.props;
    const { account } = this.props;

    return (
        <AppBar position="absolute" className={classes.appBar}>
          <Toolbar>
            <IconButton className={classes.menuButton} color="inherit" aria-label="Open drawer">
              <MenuIcon />
            </IconButton>
            <Link to="/"><img alt="logo" src="/images/logo.png" className={classes.logo}/></Link>
            {/*<div className={classes.search}>*/}
              {/*<div className={classes.searchIcon}>*/}
                {/*<SearchIcon />*/}
              {/*</div>*/}
              {/*<Input*/}
                {/*placeholder="Search…"*/}
                {/*disableUnderline*/}
                {/*classes={{*/}
                  {/*root: classes.inputRoot,*/}
                  {/*input: classes.inputInput,*/}
                {/*}}*/}
              {/*/>*/}
            {/*</div>*/}
            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              { account ? <span className={classes.account}>{account.name}</span> : null }
              {/*<IconButton color="inherit">*/}
                {/*<Badge className={classes.margin} badgeContent={4} color="secondary">*/}
                  {/*<MailIcon />*/}
                {/*</Badge>*/}
              {/*</IconButton>*/}
              {/*<IconButton color="inherit">*/}
                {/*<Badge className={classes.margin} badgeContent={17} color="secondary">*/}
                  {/*<NotificationsIcon />*/}
                {/*</Badge>*/}
              {/*</IconButton>*/}
              <IconButton color="inherit" onClick={() => window.open('https://help.staza.io','blank')}>
                  <HelpIcon />
              </IconButton>
              {/*<IconButton color="inherit" onClick={showAccount}>*/}
                {/*<SettingsIcon/>*/}
              {/*</IconButton>*/}
              <IconButton
                onClick={showProfile}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <IconButton color="inherit" onClick={onLogout}>
                <LogoutIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
    );
  }
}

PrimarySearchAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  onLogout: PropTypes.func.isRequired,
  showProfile: PropTypes.func.isRequired,
  showAccount: PropTypes.func.isRequired,
};

export default withStyles(styles)(PrimarySearchAppBar);


// WEBPACK FOOTER //
// ./src/components/Dashboard/PrimarySearchAppBar/index.js